import {API_ROOT} from './.env'
import {buildUri} from './index'

const ENTITIES = 'entities/'

export default {
    entities(id = null, params) {
        return API_ROOT + ENTITIES + (id || '') + buildUri(params)
    },

    findCommunity(id) {
        return API_ROOT + 'search/entity-names/' + id;
    },

    entityTypes: API_ROOT + 'options?fields=entityTypes',

    leaderships(entityId, params) {
        let entity = this.entities(entityId);

        return entity + '/leaderships/' + buildUri(params)
    },

    leaders(entityId, leaderId = null, params) {
        let entity = this.entities(entityId);

        return entity + '/leaders/' + (leaderId ? leaderId : '') + buildUri(params)
    },

    memberships(entityId, params) {
        let entity = this.entities(entityId);

        return entity + '/memberships/' + buildUri(params)
    },

    members(entityId, params) {
        let entity = this.entities(entityId);

        return entity + '/profiles/' + buildUri(params)
    },

    exportMembers(entityId, params) {
        let entity = this.entities(entityId);

        return entity + '/profiles/export' + buildUri(params)
    },

    announcements(entityId, params) {
        let entity = this.entities(entityId);
        return entity + '/resource/announcements/' + buildUri(params)
    },

    announcement(entityId, announcement_id, params) {
        let entity = this.entities(entityId);
        return entity + '/resource/announcements/' + announcement_id + '/' + buildUri(params)
    },

    announcementMeta(entityId, announcement_id, params) {
        let entity = this.entities(entityId);
        return entity + '/resource/announcements/' + announcement_id + '/meta' + buildUri(params)
    },

    announcementSync(entityId, announcement_id, params) {
        let entity = this.entities(entityId);
        return entity + '/resource/announcements/' + announcement_id + '/subscribers/sync' + buildUri(params)
    },

    entityRoles(entityId, params) {
        let entity = this.entities(entityId);
        return entity + '/roles/' + buildUri(params)
    },

    entityRole(entityId, role_id, params) {
        let entity = this.entities(entityId);
        return entity + '/roles/' + role_id + '/' + buildUri(params)
    },

    entityRoleTypes(entityId) {
        let entity = this.entities(entityId);

        return entity + '/role-types/'
    },
    entityPhones(entityId, params) {
        let entity = this.entities(entityId);
        return entity + '/phones/' + buildUri(params)
    },
    entityEmails(entityId, params) {
        let entity = this.entities(entityId);
        return entity + '/emails/' + buildUri(params)
    },
    entityAddresses(entityId, params) {
        let entity = this.entities(entityId);
        return entity + '/addresses/' + buildUri(params)
    },

    entityLinks(entityId, linkId, params) {
        let entity = this.entities(entityId);
        return entity + '/resource/links/' + (linkId || '') + buildUri(params)
    },

    entityAlbums(entityId, albumsId, params) {
        let entity = this.entities(entityId);
        return entity + '/resource/albums/' + (albumsId || '') + buildUri(params)
    },

    entityAlbumPhotos(entityId, albumsId, params) {
        let entity = this.entities(entityId);
        return entity + '/resource/albums/' + (albumsId) + '/photos' + buildUri(params)
    },

    entityAlbumPhoto(entityId, albumsId, photo_id, params) {
        let entity = this.entities(entityId);
        return entity + '/resource/albums/' + (albumsId) + '/photos/' + photo_id + buildUri(params)
    },

    entityPhotos(entityId, photoId, params) {
        let entity = this.entities(entityId);
        return entity + '/resource/links/' + (photoId || '') + buildUri(params)
    },

    entityVideos(entityId, videoId, params) {
        let entity = this.entities(entityId);
        return entity + '/resource/videos/' + (videoId || '') + buildUri(params)
    },

    entityDocs(entityId, docId, params) {
        let entity = this.entities(entityId);
        return entity + '/resource/documents/' + (docId || '') + buildUri(params)
    },

    entityAudios(entityId, audioId, params) {
        let entity = this.entities(entityId);
        return entity + '/resource/audios/' + (audioId || '') + buildUri(params)
    },

    entityNotes(entityId, noteId, params) {
        let entity = this.entities(entityId);
        return entity + '/resource/notes/' + (noteId || '') + buildUri(params)
    },

    entitySystemRoles(id, params) {
        return this.entities(id) + '/system-roles' + buildUri(params)
    },

    entitySystemRole(entityId, id, params) {
        return this.entities(entityId) + '/system-roles/' + id + '/search-available-members' + buildUri(params)
    },

    entityProfiles(id, params) {
        return this.entities(id) + '/profiles' + buildUri(params)
    },

    approveJoin(id) {
        return this.entities(id) + '/approve-join-request'
    },

    declineJoin(id) {
        return this.entities(id) + '/decline-join-request'
    },

    entityNewProfile(id) {
        return this.entities(id) + '/new-profiles';
    }
}



// WEBPACK FOOTER //
// ./src/api/entities.js